import * as React from "react";
function SvgIcWiFi(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.023 15.807A10.795 10.795 0 0015.807 5.023h-.75A10.045 10.045 0 015.023 15.057v.75z"
        fill="currentColor"
      />
      <path
        d="M5.023 11.981a6.966 6.966 0 006.958-6.958h-.75a6.215 6.215 0 01-6.208 6.208v.75zM18.926 5A13.85 13.85 0 015 19.074v.75A14.593 14.593 0 0019.676 5h-.75z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.437 6.693a.924.924 0 11-1.026-1.537.924.924 0 011.026 1.537zm-.392-.894a.174.174 0 00-.123-.051c-.19 0-.192.348 0 .348a.174.174 0 00.123-.297z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcWiFi;
